/* eslint-disable */
/**
 * disabling eslint is required here to disable prefer-const which auto replace const with let if variable nto changes within this file
 * https://eslint.org/docs/latest/rules/prefer-const
 */
/** react-window usage threshold for single and multi selects */
export let largeListThreshold = 500;
/* eslint-enable */